module.exports = __webpack_public_path__ + "img/philip.4f3a0e37.png";